import { render, staticRenderFns } from "./TeachingVideo.vue?vue&type=template&id=e64163f8&scoped=true&"
import script from "./TeachingVideo.vue?vue&type=script&lang=js&"
export * from "./TeachingVideo.vue?vue&type=script&lang=js&"
import style0 from "./TeachingVideo.vue?vue&type=style&index=0&id=e64163f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64163f8",
  null
  
)

export default component.exports